// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"588":"dfb73598","865":"56bebbfa","878":"dbbaedcf"}[chunkId] + ".chunk.css";
};